<script context="module" lang="ts">
    export interface TileProps {
        indice: number;
        id_partner: string;
        title: string;
        text: string;
        url_training: string;
    }
    
</script>

<script lang="ts">

    import { onMount } from 'svelte';
    import { storeLanguage, lang_fr } from "../scripts/store";
    import { storePartners, storeEcosystemsError } from '../scripts/ecosystem';
    import { getPartners } from '../scripts/apiEcosystems';
    import { addNotificationError }  from "../scripts/toaster";
    export let props: TileProps;

    var image_logo = "";

    onMount(async () => {
        getPartnersIfEmpty();
        image_logo = getLogo(props.id_partner);
	});
    
    /**
     * getPaertnersIfEmpty
     */
     function getPartnersIfEmpty() {
        if ($storePartners.length <= 0) {
            const returnValue = getPartners();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storeEcosystemsError);
                };
            });
        }
    }

    /**
     * getLogo
     */
     function getLogo(icon): string {
        var is_find = false;
        var return_value = "";
        if ($storePartners.length > 0) {
            $storePartners.forEach(partner => {
                if (partner.id == icon && !is_find) {
                    if (partner.logo_home != "") {
                        return_value = "../assets/images/ecosystem/"+icon+"_home_"+partner.logo_home;
                    } else {
                        return_value = "../assets/images/ecosystem/"+icon+"_"+partner.logo;
                    }
                }
            })
        }
        return return_value;
    }

</script>

<style lang="scss">
	.tile {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin: 60px 0 0 0;
        &__icon {
            height: 70px;
            margin: 0 0 30px 0;
            background-color: $color_primary;
            border-radius: 10px;
            &__pair {
                background-color: $color_text;
            }
        }
        &__title {
            padding: 0 0 30px 0;
            text-align: center;
        }
        &__text {
            padding: 0 16px 0 16px;
            text-align: center;
            padding: 0 0 30px 0;
        }
        &__url {
            padding: 0 16px 0 16px;
            text-align: center;
            padding: 0 0 30px 0;
        }
	}

    @include large {
        .tile {
            margin: 60px 15px 0 15px;
            padding: 30px 30px 30px 30px;
            transition: all 1s;
            border-radius: 20px 20px 20px 20px;
            justify-content: flex-start;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            &:hover {
                color: $color_primary;
                background-color: $color_grey;
                box-shadow: 8px 8px 8px $color_text;
            }
            &__title {
                text-align: center;
            }
            &__url {
                cursor: pointer;
            }
        }
    }

</style>

<div class="tile">
    <img class="tile__icon" class:tile__icon__pair={props.indice%2==0} alt="icon" src={image_logo}>
    <div class="tile__title font__h3">{props.title}</div>
    <div class="tile__text">{props.text}</div>
    {#if (props.url_training != "" && props.url_training != null)}
    <div class="tile__url">
        {#if ($storeLanguage == $lang_fr)}
        <a href={props.url_training} target="_blank" title={props.url_training}>plus d'infos ...</a>
        {:else}
        <a href={props.url_training} target="_blank" title={props.url_training}>more infos ...</a>
        {/if}
    </div>
    {/if}
</div>
